module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Stetten_AG-89d02da8b35ebf8fe9ee1f9dd7d21db3.svg";